import { Heading, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { useCredenciaisIntegracaoQuery } from 'graphql/hooks.generated'
import { CredencialIntegracaoQueryInput } from 'graphql/types.generated'
import React, { useState } from 'react'

import { CredenciaisIntegracaoForm } from './CredenciaisIntegracaoForm'
import { CredenciaisIntegracaoTable } from './CredenciaisIntegracaoTable'

export function CredenciaisIntegracaoBox() {
  const [filter, setFilter] = useState<CredencialIntegracaoQueryInput>({ pageParams: { page: 0 } })

  const { data, loading, refetch } = useCredenciaisIntegracaoQuery({
    variables: {
      input: filter,
    },
  })

  return (
    <VFlow vSpacing={0.5}>
      <Heading level={3}>Cadastrar credencial</Heading>

      <Box>
        <VFlow>
          <CredenciaisIntegracaoForm refetch={refetch} />
          <CredenciaisIntegracaoTable data={data} loading={loading} setFilter={setFilter} refetch={refetch} />
        </VFlow>
      </Box>
    </VFlow>
  )
}
